import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { FDStack, FDLabelText, tokens } from '@facet-wealth/design';
import { dataAttrs } from 'Helpers/Testing';

const useStyles = buildUseStyles('SmallNumberStepper', (theme) => ({
  dot: {
    width: theme.spacing(1),
    height: theme.spacing(1),
    borderRadius: '50%',
    backgroundColor: tokens.color_stone_700, // If we decide this is worth moving to the DS this should become a semantic color
  },
  dotFilled: {
    backgroundColor: theme.palette.primary.main,
  },
}));

export const SmallNumberStepper = ({ labelPrefix, numCompleted, numSteps }) => {
  const classes = useStyles();

  if (numSteps === 0) {
    return null;
  }

  const labelPrefixWithSpacing = labelPrefix ? `${labelPrefix} ` : '';
  return (
    <FDStack direction={'column'} justifyContent={'center'} alignItems={'center'} spacing={1} {...dataAttrs(`small-number-stepper-${numCompleted}`)}>
      <FDLabelText value={`${labelPrefixWithSpacing}${numCompleted} of ${numSteps}`} />
      <FDStack width={'100%'} justifyContent={'center'} alignItems={'center'} spacing={1}>
        {[...Array(numSteps)].map((_, i) => {
          return (
            <div
              key={i} // eslint-disable-line react/no-array-index-key -- we don't have anything better to use here than the array index
              className={classNames(classes.dot, {
                [classes.dotFilled]: i < numCompleted,
              })}
            />
          );
        })}
      </FDStack>
    </FDStack>
  );
};

SmallNumberStepper.defaultProps = {
  labelPrefix: '',
};

SmallNumberStepper.propTypes = {
  labelPrefix: PropTypes.string,
  numSteps: PropTypes.number.isRequired,
  numCompleted: PropTypes.number.isRequired,
};
